import { Compass, Ship, Users, Sparkles } from "lucide-react";

const items = [
  { icon: Compass, label: "Curated Travel Options" },
  { icon: Ship, label: "Resort Stays & Cruises" },
  { icon: Users, label: "Group Travel Friendly" },
  { icon: Sparkles, label: "Simple Planning Support" },
];

export const TrustBar = () => {
  return (
    <section data-testid="trust-bar" className="bg-[#EAE4DA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-7">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4">
          {items.map(({ icon: Icon, label }) => (
            <div key={label} className="flex items-center gap-3 justify-center md:justify-start">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-terracotta">
                <Icon size={20} strokeWidth={1.5} />
              </span>
              <span className="text-sm font-semibold text-ink">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
